import { render, staticRenderFns } from "./FormControlModulestructureEndYear.vue?vue&type=template&id=c55e8cee&scoped=true"
import script from "./FormControlModulestructureEndYear.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlModulestructureEndYear.vue?vue&type=script&setup=true&lang=js"
import style0 from "./FormControlModulestructureEndYear.vue?vue&type=style&index=0&id=c55e8cee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c55e8cee",
  null
  
)

export default component.exports